import _ from 'lodash'

import { LOAD_REALESTATES_ESTATES_OWNERSHIP_DATA_TABLE, DATA_TABLE_REQUEST } from './constants'

import config from '../../../../../../../../../../../config'

export function loadDataTable(id, page, rowsPerPage, sorting) {
    return {
        type: LOAD_REALESTATES_ESTATES_OWNERSHIP_DATA_TABLE,
        data: {
            id,
            page,
            rowsPerPage,
            sorting,
        },
    }
}

export function loadDataTableRequest(module, id, blockKey, qs) {
    const tableConfig = _.get(config, `api.${module}.${blockKey}.extended.list`, {})

    return {
        type: DATA_TABLE_REQUEST(module, id, blockKey),
        payload: {
            ...tableConfig,
            uriParams: {
                [config.modules[module].blockIdKey]: id,
            },
            qs,
        },
    }
}
